import React, { memo } from 'react';
import { useTheme } from '@material-ui/core';

import { TelexList } from './TelexList/TelexList';
import { useTelegrams } from './useTelegrams';
import { itemStyle } from './useStyles';

export const Telegrams = memo(() => {
    const { telegrams, handleClickOfp, handleClickTelegram, handleShowAttachment } = useTelegrams();
    const theme = useTheme();

    const getStyle = React.useCallback(
        (isDisabled, defaultStyle) => {
            const { disabledColor } = theme.palette;
            defaultStyle = defaultStyle || itemStyle;

            return isDisabled ? { ...defaultStyle, color: disabledColor } : defaultStyle;
        },
        [theme]
    );

    return (
        <TelexList
            getStyle={getStyle}
            telegrams={telegrams}
            onOfpClick={handleClickOfp}
            onClickTelegram={handleClickTelegram}
            onAttachmentClick={handleShowAttachment}
        />
    );
});

Telegrams.displayName = 'Telegrams';
